import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button, Typography } from 'antd';
import { MoreOutlined, InfoCircleFilled } from '@ant-design/icons';
import { useDropdownMenu } from './hooks/useDropdownMenu';
import { useDeleteProjectMutation } from '@/redux';
import { confirmation } from '@/components';
import { ProjectDto } from '@/core';
import classes from './Project.module.scss';

type ProjectProps = {
  onClickMenuRename: () => void;
  projectData: ProjectDto;
};

type ConfirmationBodyProps = {
  name: string;
};

const ConfirmationBody = ({ name }: ConfirmationBodyProps) => {
  return (
    <div>
      <Typography.Paragraph>
        Delete forever? Are you sure you want to delete <b>{name}</b> forever?
      </Typography.Paragraph>
      <Typography.Paragraph className={classes.confirmationBodyText}>
        <InfoCircleFilled className={classes.warningIcon} /> You won't be able to get project, constructed
        templates, results back.
      </Typography.Paragraph>
    </div>
  );
};

export const Project = ({ onClickMenuRename, projectData }: ProjectProps) => {
  const { t } = useTranslation();
  const { name, description, id } = projectData;
  const navigate = useNavigate();
  const [deleteProject] = useDeleteProjectMutation();

  const onClickMenuDelete = () => {
    confirmation.show({
      title: t('projects.deleteConfirmation.title'),
      body: <ConfirmationBody name={name} />,
      confirm: t('projects.deleteConfirmation.submit', { projectName: name }),
      isConfirmButtonDanger: true,
      onConfirm: () => deleteProject({ id }).unwrap(),
    });
  };
  const onClickMenuEdit = () => navigate(`/projects/constructor/${id}`);
  const onClickProject = () => navigate(`/projects/project/${id}`);

  const menu = useDropdownMenu({ onClickMenuDelete, onClickMenuEdit, onClickMenuRename });

  return (
    <div className={classes.cardWrapper} onClick={onClickProject}>
      <Typography.Title level={4}>{name}</Typography.Title>
      <Typography.Text type="secondary">{description}</Typography.Text>
      <Dropdown className={classes.dropdownToggler} overlay={menu} trigger={['click']}>
        <Button
          icon={<MoreOutlined className={classes.dropdownTogglerIcon} />}
          type="link"
          onClick={(e) => {
            e.stopPropagation();
          }}
        ></Button>
      </Dropdown>
    </div>
  );
};
